<template>
  <div class="blog-area si-without-border-radius pb-75">
    <div class="container mw-1356">
      <div class="section-title mw-860 m-auto text-center">
        <span class="top-title">المدونة والنصائح</span>
        <h2>أحدث المقالات والإرشادات لتجربة مشاهدة مثالية</h2>
      </div>

      <div class="row">
        <div
          v-for="(post, index) in blogPosts"
          :key="index"
          :class="getColumnClass(index)"
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-delay="200"
        >
          <div class="blog-single-item transition-y">
            <RouterLink :to="post.detailsLink" class="d-block blog-img">
              <img :src="post.image" :alt="post.title" />
            </RouterLink>

            <div class="blog-content">
              <RouterLink :to="post.tagLink" class="tag">
                {{ post.category }}
              </RouterLink>
              <h3>
                <RouterLink :to="post.detailsLink">{{ post.title }}</RouterLink>
              </h3>
              <ul class="d-flex align-items-center flex-wrap ps-0 mb-0">
                <li class="d-flex align-items-center">
                  <i class="ti ti-calendar-week"></i>
                  <span>{{ post.date }}</span>
                </li>
                <li class="d-flex align-items-center">
                  <i class="ti ti-clock"></i>
                  <span>قراءة في {{ post.readTime }} دقائق</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";

export default defineComponent({
  name: "OurLatestArticles",
  setup() {
    const blogPosts = ref([
      {
        title:
          "كيف تجعل بث المباريات والمسلسلات أكثر متعة وثباتاً باستخدام سيرفراتنا السريعة",
        category: "دعم فني",
        date: "23 يناير، 2026",
        readTime: 5,
        image: require("@/assets/images/blog-1.jpg"),
        detailsLink: "/blog-details",
        tagLink: "/tags",
      },
      {
        title: "لماذا يعتبر استقرار سرعة الإنترنت مفتاحاً لتشغيل قنوات 4K بدون تقطيع؟",
        category: "معرفة",
        date: "22 يناير، 2026",
        readTime: 3,
        image: require("@/assets/images/blog-2.jpg"),
        detailsLink: "/blog-details",
        tagLink: "/tags",
      },
      {
        title: "أفضل 5 نصائح لتسريع استجابة الشاشات الذكية وتطبيقات التشغيل الفوري",
        category: "نصائح تفعيل",
        date: "21 يناير، 2026",
        readTime: 2,
        image: require("@/assets/images/blog-3.jpg"),
        detailsLink: "/blog-details",
        tagLink: "/tags",
      },
    ]);

    const getColumnClass = (index: number) => {
      return index === 0 ? "col-lg-6" : "col-lg-3 col-md-6";
    };

    return {
      blogPosts,
      getColumnClass,
    };
  },
});
</script>